import { EntitySearchFilterBar } from 'src/components/EntitySearch';
import { FilterDropdownItem } from 'src/components/Filters';
import { usePurchaseFilters } from 'src/components/MainFilterBar/usePurchaseFilters';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  Feature,
  PurchaseOrderQueryV2,
  PurchaseSearchResult,
} from 'src/WebApiController';

export const PurchaseSearchFilterBar = (props: {
  activeSearchConfig?: PurchaseSearchResult;
  onSubmitFilter?: (query: PurchaseOrderQueryV2) => void;
  selectedFilters?: FilterDropdownItem[];
  setSelectedFilters: (sf: FilterDropdownItem[]) => void;
}) => {
  const hasPurchaseCommissionFilterInSearchViewFeature = useUserHasFeature(
    Feature.PurchaseCommissionFilterInSearchView
  );
  const hasConsignmentFilterPurchaseSearchViewFeature = useUserHasFeature(
    Feature.ConsignmentFilterPurchaseSearchView
  );
  const hasSearchViewVenueFilterFeature = useUserHasFeature(
    Feature.SearchViewVenueFilter
  );
  const hasSearchViewPerformerFilterFeature = useUserHasFeature(
    Feature.SearchViewPerformerFilter
  );
  const hasConsignmentDealFeature = useUserHasFeature(Feature.ConsignmentDeal);

  const filters = usePurchaseFilters({
    isHorizontalLayout: true,
    showCommissionerFilter: hasPurchaseCommissionFilterInSearchViewFeature,
    showConsignmentFilter:
      hasConsignmentDealFeature &&
      hasConsignmentFilterPurchaseSearchViewFeature,
    showCatalogFilters: true,
    showVenueFilter: hasSearchViewVenueFilterFeature,
    showPerformerFilter: hasSearchViewPerformerFilterFeature,
  });

  return (
    <EntitySearchFilterBar
      {...props}
      filters={filters}
      mandatoryFiltersToShow={['purchaseDates']}
    />
  );
};
